import React from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import {
  BiContextProvidedValue,
  BiData,
  DefaultBiEvent,
} from '@wix/da-bi/pkg/events';
import TierIcon from '@wix/da-ds/pkg/Icons/16x16/Tier';
import useDeviationStats from './useDeviationStats';
import Stat from './Stat';

export interface Props {
  deviation: PapiDeviation;
  className?: string;
  /** don't display language after stat count */
  onlyNumbers?: boolean;
}

const SubscriberStat: React.FC<Props> = ({
  deviation,
  onlyNumbers,
  className,
}) => {
  const { subscribers, isSubscribable, isInSubscription } =
    useDeviationStats(deviation);
  const isTierRelated = isSubscribable || isInSubscription;

  const isShown = isTierRelated && !!subscribers;
  return isShown ? (
    <Stat
      className={className}
      deviation={deviation}
      icon={TierIcon}
      statNameLocaleKey="deviation.stats.subscribers"
      statCount={subscribers}
      onlyNumbers={onlyNumbers}
      biData={BiData<DefaultBiEvent>({
        evid: 2,
        click_info: 'subscribers',
        sectionname: BiContextProvidedValue,
        widgetname: BiContextProvidedValue,
        typeid: BiContextProvidedValue,
        itemid: BiContextProvidedValue,
      })}
    />
  ) : null;
};
SubscriberStat.displayName = 'ViewStat';

export default SubscriberStat;
